import { AnyIfEmpty } from 'react-redux';
import { Dispatch } from 'react';
import axios from 'axios';
import { GET_LOCKER_TYPE_FAILURE, GET_LOCKER_TYPE_REQUEST, GET_LOCKER_TYPE_SUCCESS } from '../constants/locker-version.constants';

const getLockerTypesRequest = () => {
    return {
        type: GET_LOCKER_TYPE_REQUEST,
    };
};

const getLockerTypesSuccess = (lockerTypeData: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCKER_TYPE_SUCCESS,
        payload: lockerTypeData,
    };
};

const getLockerTypesFailure = (lockerTypeError: string) => {
    return {
        type: GET_LOCKER_TYPE_FAILURE,
        payload: lockerTypeError,
    };
};

export const getLockerTypes = () => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getLockerTypesRequest());
        return await axios
            .get(`/locker/get-locker-type`)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    dispatch(getLockerTypesSuccess(response.data?.data));
                } else {
                    dispatch(getLockerTypesFailure(response.data?.message));
                }
            })
            .catch((err) => dispatch(getLockerTypesFailure(err.message)));
    };
};
